import { render, staticRenderFns } from "./LLandings.vue?vue&type=template&id=aa2bc8cc&"
import script from "./LLandings.vue?vue&type=script&lang=ts&"
export * from "./LLandings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports